import Alta from './../assets/LabBrands/alta.svg'
import Alvaro from './../assets/LabBrands/alvaro.svg'
import Atalaia from './../assets/LabBrands/atalaia.svg'
import Bronstein from './../assets/LabBrands/bronstein.svg'
import CedicCedilab from './../assets/LabBrands/cedilab.svg'
import Cerpe from './../assets/LabBrands/cerpe.svg'
import Cytolab from './../assets/LabBrands/cytolab.svg'
import Delboni from './../assets/LabBrands/delboni.svg'
import Exame from './../assets/LabBrands/exame.svg'
import Frischmann from './../assets/LabBrands/frischmann.svg'
import GilsonCidrim from './../assets/LabBrands/gilsonCidrim.svg'
import Image from './../assets/LabBrands/image.svg'
import LaminaRJ from './../assets/LabBrands/laminaRj.svg'
import LaminaSC from './../assets/LabBrands/laminaSc.svg'
import Lavoisier from './../assets/LabBrands/lavoisier.svg'
import Previlab from './../assets/LabBrands/previlab.svg'
import SalomaoZoppi from './../assets/LabBrands/salomaoZoppi.svg'
import SergioFranco from './../assets/LabBrands/sergioFranco.svg'
import Valeclin from './../assets/LabBrands/valeClin.svg'
import Deliberato from './../assets/LabBrands/deliberato.svg'
import Itulab from './../assets/LabBrands/itulab.svg'
import Leme from './../assets/LabBrands/leme.svg'
import OswaldoCruz from './../assets/LabBrands/oswaldoCruz.svg'

export type Logotype = {
    [key: string]: {
        localLogo: string
        labName: string
    }
}

const logotypes: Logotype = {
    1: {
        localLogo: Delboni,
        labName: 'Delboni',
    },
    2: {
        localLogo: Lavoisier,
        labName: 'Lavoisier',
    },
    3: {
        localLogo: Bronstein,
        labName: 'Bronstein',
    },
    4: {
        localLogo: LaminaRJ,
        labName: 'Lâmina',
    },
    8: {
        localLogo: Frischmann,
        labName: 'Frischmann ',
    },
    10: {
        localLogo: Alvaro,
        labName: 'Alvaro',
    },
    12: {
        localLogo: Image,
        labName: 'Image',
    },
    13: {
        localLogo: LaminaSC,
        labName: 'Lâmina Diagnósticos',
    },
    14: {
        localLogo: Atalaia,
        labName: 'Atalaia',
    },
    15: {
        localLogo: Exame,
        labName: 'Exame',
    },
    19: {
        localLogo: Alta,
        labName: 'Alta',
    },
    24: {
        localLogo: SergioFranco,
        labName: 'Sérgio Franco',
    },
    27: {
        localLogo: Cytolab,
        labName: 'Cytolab',
    },
    32: {
        localLogo: Previlab,
        labName: 'Previlab',
    },
    34: {
        localLogo: Cerpe,
        labName: 'Cerpe',
    },
    37: {
        localLogo: GilsonCidrim,
        labName: 'Gilson Cidrim',
    },
    39: {
        localLogo: OswaldoCruz,
        labName: 'Laboratório Oswaldo Cruz',
    },
    40: {
        localLogo: Leme,
        labName: 'Leme',
    },
    42: {
        localLogo: SalomaoZoppi,
        labName: 'Salomão Zoppi',
    },
    59: {
        localLogo: Valeclin,
        labName: 'Valeclin',
    },
    101: {
        localLogo: CedicCedilab,
        labName: 'Cedic Cedilab',
    },
    102: {
        localLogo: Deliberato,
        labName: 'Deliberato',
    },
    105: {
        localLogo: Itulab,
        labName: 'Itulab',
    },
}
export default logotypes
